var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:callback"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1999 16.9496C13.1999 16.9496 15.1999 15.6496 15.5999 15.4496C15.9999 15.2496 16.4499 15.1496 16.6999 15.3496C17.0999 15.5996 20.4499 17.7996 20.7499 17.9996C21.0499 18.1996 21.1499 18.7496 20.7999 19.2996C20.3999 19.8496 18.6499 22.0496 17.8999 21.9996C17.1499 21.9996 13.6999 22.1996 7.74994 16.2996C1.79994 10.3496 1.99994 6.89956 1.99994 6.14956C1.99994 5.39956 4.14994 3.59956 4.69994 3.24956C5.24994 2.84956 5.79994 2.99956 5.99994 3.29956C6.19994 3.59956 8.39994 6.94956 8.64994 7.34956C8.79994 7.59956 8.74994 8.04956 8.54994 8.44956C8.34994 8.84956 7.04994 10.8496 7.04994 10.8496C7.04994 10.8496 7.39994 12.2496 9.54994 14.4496C11.7499 16.5996 13.1999 16.9496 13.1999 16.9496Z",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9f890a14167f8540f8e912c9d0d1c1a0.svg";
export { ForwardRef as ReactComponent };